import {
  Button,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Row,
  Col,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import envConfig from "../config.json";
import {
  PlusOutlined,
  CloudUploadOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import "@google/model-viewer/dist/model-viewer";
import axios from "axios";
import "./ModelUpload.css";
import { useTheme } from "../components/ThemeContext";
/**
 * Component to manage asset upate
 */
const UpdateAsset = (props) => {
  const { instance } = useMsal();
  const { title, assetId, fetch3DCEModels, handleCancel } = props;
  const [tag, setTag] = useState("");
  const [icon, setIcon] = useState();
  const [asset, setAsset] = useState();
  const [showProgress, setShowProgress] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [formKey, setFormKey] = useState(0);
  const [assetValidation, setAssetValidation] = useState(false);
  const [thumbnailValidation, setThumbnailValidation] = useState(false);
  const [isSaving, setIsSaving] = useState(true);
  const [file, setFile] = useState();
  const { theme } = useTheme();
  const filePropsThumbnail = {
    name: "files",
    multiple: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "error") {
        message.error({
          content: `${info.file.name} file upload failed.`,
          className: 'custom-message-failure',
        });
      }
    },
    beforeUpload() {
      return false;
    },
  };

  /**
   * Function to handle the icon
   * @param {*} e an object
   * @returns
   */
  const handleIcon = (e) => {
    const isJpgOrPng =
      e.file.type === "image/jpeg" || e.file.type === "image/png";
    const isLt2M = e.file.size / 1024 / 1024 < 10;
    if (!isJpgOrPng) {
      message.error({
        content: "You can only upload JPG/PNG file",
        className: 'custom-message-failure',
      });
      setThumbnailValidation(true);
      return;
    } else if (!isLt2M) {
      message.error({
        content: "Image must smaller than 10MB",
        className: 'custom-message-failure',
      });
      return;
    }
    const result = URL.createObjectURL(e.file);
    setPreviewImage(result);
    setIcon(e.file);
    setThumbnailValidation(false);
  };
  /**
   * Function to reset fields
   */
  const resetFields = () => {
    setFormKey((formKey || 0) + 1);
    setFile("");
    setPreviewImage(null);
  };
  const msalToken = localStorage.getItem("msal.accesstoken");
  const config = {
    headers: {
      Authorization: `Bearer ${msalToken}`,
    },
    "Content-Type": "application/x-www-form-urlencoded",
  };
  const urlUpload = async (modelUrl, file) => {
    await readFileDataAsBuffer(file);
    await axios({
      method: "put",
      url: modelUrl, //API url
      data: file, // Buffer
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
  };
  /**
   * Function to read the file as buffer
   * @param {*} file
   * @returns
   */
  const readFileDataAsBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  /**
   * Function to save 3DCE model
   */
  const save3DCEModel = async () => {
    try {
      setShowProgress(true);
      const token3DCE = localStorage.getItem("accesstokence");
      const thumbFields = {
        authToken: token3DCE,
        filename: icon?.name,
      };
      const thumbUpload = await axios.post(
        `${envConfig.aotmwapi}/api/3d-cms/continuumengine/asset`,
        thumbFields,
        config
      );
      await urlUpload(thumbUpload.data.url, icon);
      const metaData = {
        assetType: "mesh",
        title: title,
        description: "",
        collections: "",
        tags: "",
        additionalMetadata: [],
        defaultMetadata: {
          "Author": "AOT Author",
          "Copyright Notes": "AOT Copyright",
          "Owner": "AOT Owner",
          "Required Metadata": "AOT Required"
        },
        conversionDetails: {
          conversionFormats: ["glb"],
          addCollision: false,
          hasLod: false,
          levelOfDetails: [],
        },
        thumbnail: thumbUpload.data.key,
      };
      const assetFields = {
        authToken: token3DCE,
        filename: asset?.name,
        assetId: assetId,
        metadata: metaData,
      };
      const assetUpload = await axios.post(
        `${envConfig.aotmwapi}/api/3d-cms/continuumengine/asset`,
        assetFields,
        config
      );
      await urlUpload(assetUpload.data.url, asset);
      setShowProgress(false);
      message.success({
        content: "Model uploaded successfully",
        className: 'custom-message-success',
      });
      resetFields();
      handleCancel();
      fetch3DCEModels();
    } catch (error) {
      console.error("error in urlUpload");
      if (error.response.status === 401) {
        localStorage.removeItem("checkRole");
        const logoutRequest = {
          postLogoutRedirectUri: envConfig.redirectUri,
        };
        instance.logoutRedirect(logoutRequest);
      }
    }
  };
  /**
   * Function to validate selected fields
   * @param {*} value
   * @returns
   */
  const validateSelectedFiles = (value) => {
    let ext = value.file.name.toLowerCase().split(".");
    ext = ext[ext.length - 1];
    if (ext === "gltf" || ext === "glb" || ext === "fbx" || ext === "obj") {
      setAssetValidation(false);
      setFile(URL.createObjectURL(value.file));
      setAsset(value.file);
    } else {
      setAssetValidation(true);
      setThumbnailValidation(false);
      message.error({
        content: "You can only upload GLTF/Glb/Fbx/Obj file",
        className: 'custom-message-failure',
      });
    }
  };
  /**
   * React default hook to handle outside effects
   */
  useEffect(() => {
    if (title && asset && icon && tag) {
      setIsSaving(false);
    } else {
      setIsSaving(true);
    }
  }, [title, asset, icon, tag]);

  return (
    <Spin spinning={showProgress}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={12}>
          <div>
            <Form
              name="model"
              key={formKey}
              layout="vertical"
              initialValues={{
                remember: true,
              }}
            >
              <Form.Item label="Title" name="title">
                <Input maxLength={50} defaultValue={title} readOnly
                  style={{ border: `1px solid ${theme === "dark" ? "#1D5F70" : "#CADCF8"}` }}
                  className="title" />
              </Form.Item>
              <Form.Item
                label="Tag"
                name="tag"
                value={tag}
                onChange={(e) => setTag(e.target.value)}
                rules={[
                  {
                    required: true,
                    message: "Please enter the tag!",
                  },
                ]}
              >
                <Input maxLength={50} />
              </Form.Item>
              <Row gutter={16}>
                <Col className="gutter-row" span={18}>
                  <Form.Item
                    name="asset"
                    label={
                      <span>
                        3D File<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Upload.Dragger
                      name="asset"
                      maxCount={1}
                      beforeUpload={() => false}
                      onChange={validateSelectedFiles}
                    >
                      <p className="dropzone-icon">
                        <CloudUploadOutlined />
                      </p>
                      <p className="dropzone-text">
                        Drag and drop the asset or click to select files.
                        Please upload GLTF/Glb/Fbx/Obj file only
                      </p>
                    </Upload.Dragger>
                    {assetValidation || thumbnailValidation ? (
                          <p id="error_color">
                            {thumbnailValidation === true ? "Please upload JPG or PNG file only" : "Please upload GLTF or Glb file only"}
                          </p>
                        ) : null}
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label={
                      <span>
                        Thumbnail<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </span>
                    }
                    name="Thumbnail"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <div className="clearfix">
                      {/* <Tooltip
                          title="Click to upload new thumbnail"
                          placement="bottomRight"
                        > */}
                      <Upload
                        {...filePropsThumbnail}
                        listType="picture-card"
                        showUploadList={false}
                        onChange={handleIcon}
                        onRemove={() => {
                          setPreviewImage(null);
                        }}
                      >
                        {previewImage ? (
                          <img
                            alt="preview"
                            className="imgWidth"
                            src={previewImage}
                          />
                        ) : (
                          <div>
                            <PlusOutlined />
                            <div className="ant-upload-text">
                              Upload thumbnail
                            </div>
                          </div>
                        )}
                      </Upload>
                      {/* </Tooltip> */}
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
        <Col className="gutter-row" span={12}>
          <div>
            <model-viewer
              src={file}
              shadow-intensity="1"
              camera-controls
              auto-rotate
              ar
              class="modelviewerStyle"
            >
              <div id="lazy-load-poster" slot="poster"></div>
              <div id="button-load" slot="poster">
                <PlayCircleOutlined /> Preview
              </div>
            </model-viewer>
          </div>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={8}>
          <Button onClick={props.handleCancel} className="cancelButton">
            Cancel{" "}
          </Button>
        </Col>
        <Col span={8} offset={8} className="divAlignRight">
          <Button className="model-confirm-yes"
            style={{
              backgroundColor: isSaving ? "#7a7a7a" : "#1d5f70",
              color: isSaving ? "#999999" : "#01f1ff",
              fontWeight: "700",
              padding: "4px 64px",
            }}
            disabled={isSaving}
            onClick={() => save3DCEModel()}
          >
            Update New Version
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default UpdateAsset;
